import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { BasicButton, BasicPopover, BasicRadioGroup, BasicTable } from '../../assets/common';
import { filter_feedback } from '../../assets/img';
import styles from './ModalEditVerbatimFeedback.module.scss';
import { Radio, Space } from 'antd';
import { paginationConfig } from '../../utils/helper';
import CustomFilterTable from '../CustomFilterTable';
import { isArray, isEmpty } from 'lodash';
import talentProfileApi, { updateOtherOtherExperience, updateVerbatimFeedbacks } from '../../services/talentProfiles';
import { FEED_BACK, ITEM_EDIT_TAGGING, MODULE_FILTER_TABLE, OTHER_EXPERIENCE, VERBATIM_FEEDBACKS, MESSAGE_TYPES } from '../../utils/constants';
import DropdownEditVerbatimFeedback from '../DropdownEditVerbatimFeedback/DropdownEditVerbatimFeedback';
import { useDispatch } from 'react-redux';
import { pushMessage } from '../../store/alertMessageSlice';

const INIT_FILTER_PARAMS = {
  edgeAttributes: [],
  year: [],
  page: 1,
  limit: 10,
};

const INIT_FILTER_OPTIONS = {
  Attributes: {
    filters: [],
    years: [],
  },
  EDGE: {
    filters: [],
    years: [],
  },
};

const HIDE_OPTION = [true, false];

const customStyle = {
  width: '400px',
  display: 'flex',
  alignItems: 'center',
};

const ModalEditVerbatimFeedback = ({ show, setShow, roleUser, tokenTalentProfile, type, info, setIsCheckSubmitFB, profileId }) => {
  const [filterParams, setFilterParams] = useState(INIT_FILTER_PARAMS);
  const [radioVerbatimFeedback, setRadioVerbatimFeedback] = useState('edge');
  const [filtersOption, setFiltersOption] = useState(INIT_FILTER_OPTIONS);

  const [loadingFeedbackSummary, setLoadingFeedbackSummary] = useState(false);
  const [loadingFilterFeedback, setLoadingFilterFeedback] = useState(false);
  const [listEdit, setListEdit] = useState([]);
  const [totalListEdit, setTotalListEdit] = useState(0);
  const [itemChoose, setItemChoose] = useState({});
  const [isDisableSaveBtn, setIsDisableSaveBtn] = useState(false);
  const [listFeedbackUpdate, setListFeedbackUpdate] = useState([]);
  const [currentToggleItem, setCurrentToggleItem] = useState(null);

  const dispatch = useDispatch();

  const feedbackType = useMemo(() => {
    return radioVerbatimFeedback === 'edge' ? VERBATIM_FEEDBACKS.EDGE : VERBATIM_FEEDBACKS.ATTRIBUTES;
  }, [radioVerbatimFeedback]);

  const handleConverDateUpdateExp = (list) => {
    return list
      .filter((item) => item?.edit === true)
      .map((ele) => {
        return {
          id: ele.id,
          status: ele.status,
        };
      });
  };

  const getVerbatimFeedbacksSummaryEdit = async () => {
    const body = {
      limit: filterParams.limit,
      page: filterParams.page,
      feedbackType: feedbackType,
      years: !isEmpty(filterParams.year) ? filterParams.year.map((yearItem) => Number(yearItem)) : [],
      filters: filterParams.edgeAttributes,
    };

    try {
      setLoadingFeedbackSummary(true);
      const response = await talentProfileApi.getVerbatimFeedbacksEdit({ roleUser, profileId, body, tokenTalentProfile });
      if (response.status === 200 && response?.data?.result) {
        const tempData =
          !isEmpty(response.data.result?.feedbacks) && !isEmpty(listFeedbackUpdate)
            ? response.data.result?.feedbacks?.map((i) => {
                const isCheck = listFeedbackUpdate.map((f) => f.id).includes(i?.id);
                if (isCheck) {
                  return {
                    ...i,
                    is_hide: listFeedbackUpdate.filter((f) => f.id === i?.id)[0].is_hide,
                  };
                } else {
                  return i;
                }
              })
            : response.data.result?.feedbacks;
        setListEdit(tempData);
        setTotalListEdit(response.data.result?.totalFeedbacks);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFeedbackSummary(false);
    }
  };

  useEffect(() => {
    getVerbatimFeedbacksSummaryEdit();
  }, [roleUser.roleActive.roleId, profileId, filterParams.page, filterParams.year, filterParams.edgeAttributes, radioVerbatimFeedback]);

  useEffect(() => {
    if (isEmpty(itemChoose)) return;

    setListEdit((prev) => {
      return prev?.map((item) => {
        if (item?.id === itemChoose.indexEleEdit) {
          return {
            ...itemChoose,
            is_hide: itemChoose?.is_hide,
          };
        }
        return item;
      });
    });
    setListFeedbackUpdate((prev) => {
      if (!isEmpty(prev) && isArray(prev)) {
        const isCheck = prev.filter((i) => i?.id === itemChoose.indexEleEdit).length > 0;
        if (isCheck) {
          return prev.map((i) => {
            if (i?.id === itemChoose.indexEleEdit) {
              return {
                ...i,
                is_hide: itemChoose?.is_hide,
                type: feedbackType,
              };
            }
            return i;
          });
        } else {
          return [
            ...prev,
            {
              id: itemChoose.indexEleEdit,
              is_hide: itemChoose?.is_hide,
              page: filterParams.page,
              type: feedbackType,
            },
          ];
        }
      } else {
        return [
          {
            id: itemChoose.indexEleEdit,
            is_hide: itemChoose?.is_hide,
            page: filterParams.page,
            type: feedbackType,
          },
        ];
      }
    });
  }, [itemChoose, setListEdit, setListFeedbackUpdate]);

  const getFilterFeedback = async () => {
    try {
      const response = await talentProfileApi.getFilterVerbatimFeedbacks({
        profileId,
        roleUser,
        tokenTalentProfile,
      });

      if (response?.status === 200 && response?.data?.result) {
        setFiltersOption(response.data.result);
      }
      setLoadingFilterFeedback(false);
    } catch (error) {
      console.error(error);
      setLoadingFilterFeedback(false);
    }
  };

  const handleUpdateFeedbacks = async () => {
    try {
      let response;
      setIsDisableSaveBtn(true);
      const list = listFeedbackUpdate || [];
      const params = { type: feedbackType };
      if (type === FEED_BACK) {
        if (list && list.length === 0) return;
        response = await updateVerbatimFeedbacks({
          id: info.id,
          roleUser: info.roleUser,
          body: list,
          params,
        });
      }

      if (type === OTHER_EXPERIENCE) {
        const dataUpdate = handleConverDateUpdateExp(list);
        if (dataUpdate && dataUpdate.length === 0) return;
        response = await updateOtherOtherExperience({
          id: info.id,
          roleUser: info.roleUser,
          body: list,
        });
      }

      if (response.status === 200 && response?.data) {
        if (type === FEED_BACK) {
          setIsCheckSubmitFB((preState) => !preState);
          handleClose()
          document.body.scrollTop = 0
          dispatch(
            pushMessage({
              type: MESSAGE_TYPES.SUCCESS,
              message: VERBATIM_FEEDBACKS.SAVE_SUCCESS_MESSAGE,
              timeShow: 0,
            })
          );
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setListFeedbackUpdate([]);
      setIsDisableSaveBtn(false);
    }
  };

  useEffect(() => {
    getFilterFeedback();
  }, [roleUser.roleActive.roleId, profileId]);

  const onChangeRadioVerbatim = async ({ target: { value } }) => {
    if (!isEmpty(listFeedbackUpdate)) {
      await handleUpdateFeedbacks();
    }

    setFilterParams(INIT_FILTER_PARAMS);
    setRadioVerbatimFeedback(value);
  };

  const onApplyEdgeAttributes = useCallback(
    (filters) => {
      setFilterParams((prev) => {
        return {
          ...prev,
          page: 1,
          edgeAttributes: filters,
        };
      });
    },
    [setFilterParams]
  );

  const onApplyYear = useCallback(
    (filters) => {
      setFilterParams((prev) => {
        return {
          ...prev,
          page: 1,
          year: filters,
        };
      });
    },
    [setFilterParams]
  );

  const handleReturnFilter = (data, setListSelected, listSelected, onApplyFilters, close, filterName, loading, customStyle) => {
    return (
      <div style={{ position: 'relative' }}>
        <CustomFilterTable
          setSelectedKeys={setListSelected}
          selectedKeys={listSelected}
          filters={
            (!isEmpty(data) &&
              data.map((item) => ({
                value: item.value,
                text: item.label,
                isChecked: item.value,
              }))) ||
            []
          }
          onApplyFilters={onApplyFilters}
          isLoading={loading}
          close={close}
          filterName={filterName}
          moduleName={MODULE_FILTER_TABLE.VERBATIM_FEEDBACK}
          customStyle={customStyle}
        />
      </div>
    );
  };

  const columns = [
    {
      title: radioVerbatimFeedback === 'edge' ? 'Edge' : 'Attributes',
      dataIndex: 'filter',
      align: 'left',
      width: '20%',
      render: (_, record) => {
        return <span>{record?.filter || ''}</span>;
      },
      filterIcon: <img src={filter_feedback} alt="" />,
      filterDropdown: ({ _clearFilters, close }) => {
        const edgeAttributesFilter = radioVerbatimFeedback === 'edge' ? filtersOption.EDGE.filters : filtersOption.Attributes.filters;
        const edgeAttributesFilterData = edgeAttributesFilter.map((edgeAttributes) => ({
          label: edgeAttributes,
          value: edgeAttributes,
        }));
        const customStyle = { width: 320 };

        return handleReturnFilter(
          edgeAttributesFilterData,
          setFilterParams,
          filterParams.edgeAttributes,
          onApplyEdgeAttributes,
          close,
          'edgeAttributes',
          loadingFilterFeedback,
          customStyle
        );
      },
    },
    {
      title: 'Source',
      dataIndex: 'source',
      align: 'left',
      width: '8%',
      render: (_, record) => {
        return <span>{record?.source || ''}</span>;
      },
    },
    {
      title: 'Year',
      dataIndex: 'year',
      align: 'left',
      width: '8%',
      render: (_, record) => {
        return <span>{record.year || ''}</span>;
      },
      filterIcon: <img src={filter_feedback} alt="" />,
      filterDropdown: ({ _clearFilters, close }) => {
        const yearFilter = radioVerbatimFeedback === 'edge' ? filtersOption.EDGE.years : filtersOption.Attributes.years;
        const yearFilterData = yearFilter.map((year) => ({
          label: String(year),
          value: String(year),
        }));

        return handleReturnFilter(yearFilterData, setFilterParams, filterParams.year, onApplyYear, close, 'year', loadingFilterFeedback, {});
      },
    },
    {
      title: 'Feedback Dimension',
      dataIndex: 'feedback_dimension',
      align: 'left',
      width: '20%',
      render: (_, record) => {
        return <div style={{ minWidth: '200px' }}>{record?.feedback_dimension || ''}</div>;
      },
    },
    {
      title: 'Score',
      dataIndex: 'score',
      align: 'left',
      width: '8%',
      render: (_, record) => {
        return <span>{!isNaN(record?.score) ? record?.score : ''}</span>;
      },
    },
    {
      title: 'Excerpt Sentence',
      dataIndex: 'excerpt_sentence',
      align: 'left',
      width: '420',
      render: (_, record) => {
        return (
          <div style={customStyle}>
            <BasicPopover
              content={<div>{record?.excerpt_sentence_click || record?.excerpt_sentence}</div>}
              trigger="click"
              placement="bottom"
              getPopupContainer={(trigger) => trigger}
              open={currentToggleItem === record?.id}
              onOpenChange={(open) => {
                if (!open) {
                  setCurrentToggleItem(null);
                }
              }}
              styles={{
                minWidth: '420px',
                fontSize: '12px',
                lineHeight: '18px',
                fontWeight: 600,
                fontFamily: `'Inter', sans-serif`,
                padding: '12px',
                borderRadius: '4px',
                bg: '#000',
                color: '#fff',
                hideArrow: false,
              }}
            >
              <div
                onClick={() => {
                  setCurrentToggleItem((prev) => {
                    return isEmpty(prev) ? record?.id : null;
                  });
                }}
              >
                {record?.excerpt_sentence || ''}
              </div>
            </BasicPopover>
          </div>
        );
      },
    },
    {
      title: 'Hide',
      dataIndex: 'is_hide',
      align: 'left',
      width: 100,
      render: (_, record) => {
        return (
          <div style={{ lineHeight: '18px', minWidth: '100px' }}>
            <DropdownEditVerbatimFeedback
              listOption={HIDE_OPTION}
              type={'Short'}
              ele={record}
              kind={ITEM_EDIT_TAGGING.HIDE}
              indexEleEdit={record.id}
              setListEdit={setListEdit}
              setItemChoose={setItemChoose}
              page={filterParams.page}
            />
          </div>
        );
      },
    },
  ];

  const pagination = useMemo(() => {
    const onChange = (pageNum) => {
      setFilterParams((prevState) => ({ ...prevState, page: pageNum }));
    };
    return paginationConfig(totalListEdit || 0, filterParams.page, onChange, filterParams.limit);
  }, [totalListEdit, filterParams.page, setFilterParams, filterParams.limit]);

  const handleClose = () => {
    setShow(false);
    setCurrentToggleItem(null);
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} animation={false} dialogClassName={styles.containerModal} data-testid="edit-tagging">
        <Modal.Header closeButton className={styles.editTagging__header}>
          <Modal.Title className={styles.editTagging__title}>Edit Verbatim Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0 30px 20px' }}>
          <div className={styles.verbatimFeedback}>
            <BasicRadioGroup onChange={onChangeRadioVerbatim} value={radioVerbatimFeedback}>
              <Space direction="horizontal" className={styles.radioTitle}>
                <Radio value={'edge'}>EDGE</Radio>
                <Radio value={'attributes'}>Attributes</Radio>
              </Space>
            </BasicRadioGroup>
            <BasicTable
              className={styles.verbatimFeedback}
              rowKey={'id'}
              dataSource={listEdit?.map((i, index) => {
                return {
                  ...i,
                  index,
                };
              })}
              columns={columns}
              pagination={pagination}
              loading={loadingFeedbackSummary}
              styles={{ headerColor: '#8896A7', borderRadius: 6 }}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
            <div className={styles.editTagging__wrapBtn} style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: 0 }}>
              <BasicButton style={{ width: '110px' }} onKeyDown={() => {}} onClick={handleClose}>
                Cancel
              </BasicButton>
              <BasicButton style={{ width: '110px' }} mode="teal" onKeyDown={() => {}} disabled={isDisableSaveBtn} onClick={handleUpdateFeedbacks}>
                {(isDisableSaveBtn && <Spinner animation="border" size="sm" />) || 'Save'}
              </BasicButton>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ModalEditVerbatimFeedback;
